// extracted by mini-css-extract-plugin
export default {"main_page":"HyundaiTucson_main_page__hRVSp","car_image":"HyundaiTucson_car_image__-8hAP"};